import { MasterInstance } from "@/instance/axios";
import { PrintersGet200ResponseRowsInner } from "@sizlcorp/sizl-api-document/dist/models";
import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

export type PrinterOption = {
  value: string;
  label: string;
  group: string;
};

const getAutoCompleteKeyword = () =>
  MasterInstance.printersFindPost().then(
    (res: AxiosResponse<PrintersGet200ResponseRowsInner[]>) => res.data,
  );

export const usePrintersAutoComplete = (
  focus = false,
  keyword = "",
  options?: {
    onSuccess: (data: PrinterOption[]) => void;
  },
) => {
  return useQuery(["Printers-get-autocomplete"], () => getAutoCompleteKeyword(), {
    enabled: focus,
    select: (data: PrintersGet200ResponseRowsInner[]) =>
      data?.map((Printer) => {
        return {
          value: String(Printer.code),
          label: String(Printer.name),
          group: String(Printer.name),
        };
      }) ?? [],
    onSuccess: options?.onSuccess,
  });
};

const getPrintersByCode = (code: string | null) =>
  MasterInstance.printersFindPost({
    ...(code && { search: code }),
    searchFields: ["code"],
  }).then((res: AxiosResponse<PrintersGet200ResponseRowsInner[]>) => res.data);

export const usePrintersCode = (
  enabled: boolean,
  code: string | null,
  options?: {
    onSuccess: (data?: PrinterOption[]) => void;
  },
) => {
  return useQuery(["Printers-get-code", code], () => getPrintersByCode(code), {
    enabled: enabled ?? false,
    select: (data: PrintersGet200ResponseRowsInner[]) =>
      data?.map((Printer) => {
        return {
          value: String(Printer.code),
          label: String(Printer.name),
          group: String(Printer.name),
        };
      }),
    onSuccess: options?.onSuccess,
  });
};
